// ==============================|| WEB-COMPONENTS - LOCATIONS ||============================== //

import { PERMISSIONS } from "../permissions/permissions";

const webComponents = {
  id: 'web',
  path:"/web-content",
//   title: 'Forms',
  type: 'group',
  children: [
    {
      id: 'web-elements',
      title: 'menu.webContent',
      type: 'collapse',
      icon: 'ph ph-file-text',
      children: [
        {
          id: 'web-content',
          title: 'menu.cmsPages',
          type: 'item',
          url: '/web/pages',
          permission: PERMISSIONS.WEBCONTENT.VIEW
        }
      ]
    }
  ]
};

export default webComponents;